// PortfolioDashboard.js
import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const PortfolioDashboard = () => {
  // Donut chart data (Account Balance)
  const balanceData = [
    { name: "Invested", value: 25000 },
    { name: "Cash", value: 11388 },
  ];
  const balanceColors = ["#00b3b3", "#444"];

  // Contribution stacked bar data
  const contributionData = [
    { name: "Stocks", value: 12000, color: "#dc3545" },
    { name: "Bonds", value: 11000, color: "#ffc107" },
    { name: "Real Estate", value: 7000, color: "#28a745" },
  ];

  return (
    <div
      className="container-fluid p-3 rounded-3 mb-5"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)",
        border: "1px solid #23272f",
        color: "#fff",
      }}
    >
      <div className="row">
        {/* Account Balance Card */}
        <div className="col-md-6">
          <div className="portfolio-metric-card card p-3 shadow-sm text-white">
           <div className="card-header"> <h6 className="text-muted">Account Balance</h6></div>
           <hr></hr>
            <h5 className="text-center">$36,388.72</h5>

            {/* Donut Chart with center text */}
          {/* Donut Chart with badge */}
<div style={{ width: "100%", height: 220, position: "relative" }}>
  <ResponsiveContainer>
    <PieChart>
      <Pie
        data={balanceData}
        cx="50%"
        cy="50%"
        innerRadius={70}
        outerRadius={100}
        paddingAngle={3}
        dataKey="value"
      >
        {balanceData.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={balanceColors[index % balanceColors.length]}
          />
        ))}
      </Pie>
    </PieChart>
  </ResponsiveContainer>

  {/* Center text (Cash value) */}
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
      color: "#fff",
    }}
  >
    <h5 style={{ margin: 0 }}>$11,388</h5>
    <small className="text-muted">Cash</small>
  </div>

  {/* Green badge (+4.54%) inside donut bottom-right */}
  <div
    style={{
      position: "absolute",
      bottom: "25%",
      right: "28%",
      background: "#28a745",
      borderRadius: "50%",
      padding: "12px 16px",
      color: "#fff",
      fontWeight: "bold",
      fontSize: "14px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
    }}
  >
    +4.54%
  </div>
</div>


            <button className="btn btn-dark w-100 mt-2">
              Manage Investments
            </button>
          </div>
        </div>

        {/* Contribution Rate Card */}
        <div className="col-md-6">
          <div className="portfolio-metric-card card p-3 shadow-sm text-white">
            <div><h6 className="text-muted">Contribution Rate</h6></div>
            <hr></hr>
            <h5 className="text-center">$200.00 / mo</h5>

            {/* Horizontal bars */}
            <div className="mt-4">
              {contributionData.map((item, i) => (
                <div key={i} className="mb-4">
                  <div className="d-flex justify-content-between">
                    <span>{item.name}</span>
                    <span>${item.value}</span>
                  </div>
                  <div
                    style={{
                      background: "#444",
                      borderRadius: "6px",
                      height: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${(item.value / 12000) * 100}%`,
                        background: item.color,
                        height: "100%",
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <button className="btn btn-dark w-100 mt-2">
              Consolidate Investments
            </button>
          </div>
        </div>
      </div>

      {/* Portfolio Table */}
      <div className="portfolio-metric-card card mt-4 shadow-sm">
        <div className="card-body text-white">
          <h6 className="text-white">My Portfolio</h6>
         <div className="table-responsive">
         <table className="table table-hover table-dark table-bordered">
            <thead style={{ backgroundColor: "#00b3b3", color: "white" }}>
              <tr>
                <th>Investment</th>
                <th>Symbol</th>
                <th>Price</th>
                <th>Shares</th>
                <th>Market Value</th>
                <th>% of Portfolio</th>
                <th>Gain/Loss</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Apple</td>
                <td>AAPL</td>
                <td>$175.64</td>
                <td>20</td>
                <td>$3,512.80</td>
                <td>25%</td>
                <td style={{ color: "green", fontWeight: "bold" }}>+5.2%</td>
              </tr>
              <tr>
                <td>Tesla</td>
                <td>TSLA</td>
                <td>$725.32</td>
                <td>10</td>
                <td>$7,253.20</td>
                <td>20%</td>
                <td style={{ color: "red", fontWeight: "bold" }}>-2.1%</td>
              </tr>
              <tr>
                <td>Amazon</td>
                <td>AMZN</td>
                <td>$145.22</td>
                <td>15</td>
                <td>$2,178.30</td>
                <td>15%</td>
                <td style={{ color: "green", fontWeight: "bold" }}>+3.4%</td>
              </tr>
            </tbody>
          </table>
         </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioDashboard;
